import thunk from "redux-thunk";

const middlewares = [thunk];
export { middlewares };
